import { isValidPageId, storeNextPhotoValues } from '../utils';

export class PhotosList {
    pageId: PageId;
    tag?: string;
    pageNumber: number;

    constructor(pageId: PageId, pageNumber: number = 1, tag?: string) {
        this.pageId = pageId;
        this.pageNumber = pageNumber;
        if (tag) {
            this.tag = tag;
        }
    }

    setNextPhotoValues(id: string) {
        const pageId = this.pageId;
        const page = isValidPageId(pageId) ? pageId : null;

        const values: PageData = {
            page,
            id,
            page_number: this.pageNumber,
            ...(this.tag ? { tag: this.tag } : {}),
        };

        storeNextPhotoValues(values);
    }
}
